import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from "@angular/core";
import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { IDetailItemExpense, getEmptyDetailItemExpense } from "../expenses.interface";
import { MyErrorStateMatcher } from "../../../../shared/util/error-state-matcher";
import { AuthService } from "../../../../shared/services/auth.service";
import { ProductsService } from "../../../products-page/products/products.service";
import { DialogService } from "../../../../shared/services/dialog/dialog.service";
import { IConfirmationDialogOptions } from "../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface";
import { IVendor } from "../../../vendors-page/vendors/vendors.interface";
import { VendorsService } from "../../../vendors-page/vendors/vendors.service";
import { Observable, debounceTime, distinctUntilChanged, firstValueFrom, map, of, startWith, switchMap } from "rxjs";
import _ from "lodash";

@Component({
  selector: 'app-detail-item-expenses',
  templateUrl: './detail-item-expenses.component.html',
  styleUrls: ['./detail-item-expenses.component.css']
})
export class DetailItemExpensesComponent implements OnInit {

  @Input('vendors') vendors!: IVendor[];
  @Input('item') item!: IDetailItemExpense;
  @Input('readOnly') readOnly = false;
  @Input('pricing') pricing = true;
  @Input('disableButton') disableButton = false;
  @Output('itemChange') itemChange = new EventEmitter<any>();
  @Output('remove') remove = new EventEmitter<any>();
  form!: UntypedFormGroup;
  emptyItem = getEmptyDetailItemExpense();
  totalControl = new FormControl();
  customErrorStateMatcher = new MyErrorStateMatcher();
  $vendors: Observable<any> = of();

  constructor(
    private _AuthService: AuthService,
    private _ProductsService: ProductsService,
    private fb: UntypedFormBuilder,
    private _dialogService: DialogService,
    private _viewContainerRef: ViewContainerRef,
  ) { }

  ngOnInit(): void {
    this.initializeComponent();
  }

  initializeComponent() {
    if (!this.item) this.item = getEmptyDetailItemExpense();
    this.item.detail = this.item.detail ?? this.item.name ?? this.item.expense?.name ?? '';
    this.buildForm();
  }

  vendorsTerm: string = '';
  get f() { return this.form.controls; }
  buildForm() {
    console.log(this.item)
    const dateExpense = this.item.date ? new Date(this.item.date).toISOString().substring(0, 10) : new Date().toISOString().substring(0, 10)
    this.form = this.fb.group({
      expense: [this.item.expense || undefined],
      vendor: [this.item.vendor || undefined, Validators.compose([vendorValidator])],
      detail: [this.item.detail || ""],
      description: [this.item.description || ""],
      date: [dateExpense],
      quantity: [this.item.quantity ?? this.emptyItem.quantity],
      amount: [this.item.amount || 0],
      subtotal: [this.item.subtotal ?? this.emptyItem.subtotal],
      taxPercentage: [this.item.taxPercentage ?? undefined],
      tax: [this.item.tax ?? this.emptyItem.tax],
      total: [this.item.total ?? this.emptyItem.total]
    });

    this.$vendors = this.f['vendor'].valueChanges.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged(),
      map((value: any) => {
        // Verifica si el valor es un string o un objeto
        const term = typeof value === 'string' ? value : value?.name || '';
        this.vendorsTerm = term; // Actualiza el término de búsqueda
        return this.filterVendors(term);
      })
    );

    this.calculateTotals();
  }

  filterVendors(term: string): IVendor[] {
    return this.vendors.filter((vendor) =>
      (vendor.name || '').toLowerCase().includes(term.toLowerCase())
    );
  }


  onSelected(event: any) {
    this.onChanged(event);
  }

  onChanged(event: any) {
    console.log(event)
    if (event.expense) {
      this.item.expense = event.expense?._id;
      this.f['expense'].setValue(event.expense?._id);
      this.f['detail'].setValue(event.text ? event.text : event.expense?.name);
      this.f['description'].setValue(event.expense?.description ? event.expense.description : "");;
      this.f['amount'].setValue(event.expense?.amount ? event.expense.amount : 0);
    } else {
      this.f['detail'].setValue(event.text ?? '');
    }
    this.calculateTotals();
  }

  // filterVendors(event: Event): void {
  //   const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
  //   this.filteredVendors = this.vendors.filter(vendor =>
  //     (vendor.name || '').toLowerCase().includes(filterValue)
  //   );
  // }

  displayVendorsFn(vendor: IVendor): string {
    if (vendor?.name) {
      const name = vendor.name?.trim();
      return name;
    } else {
      return '';
    }
  }

  /*
  calculateTotals_out() {
    let total = 0;
    total = this.f['quantity'].value * this.f['amount'].value;
    this.f['total'].setValue(total);
    this.onChangeForm();
    this.f['total'].setValue(this.formatMoney(total));
  }
    */

  calculateTotals() {
    let subtotal = 0;
    let tax = 0;
    let total = 0;

    subtotal = this.f['quantity'].value * this.f['amount'].value;
    tax = (this.f['quantity'].value * this.f['amount'].value) * (this.f['taxPercentage'].value * 0.01);
    total = subtotal + tax;

    this.f['subtotal'].setValue(subtotal);
    this.f['tax'].setValue(tax);
    this.f['total'].setValue(total);

    this.onChangeForm();

    this.f['subtotal'].setValue(this.formatMoney(subtotal));
    this.f['tax'].setValue(this.formatMoney(tax));
    this.f['total'].setValue(this.formatMoney(total));
  }

  formatMoney(value: number): string {
    let valueRed = value.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (valueRed.length === 7 && value > 0) {
      valueRed = valueRed.substring(0, 1) + '.' + valueRed.substring(1);
    }
    if (valueRed.length === 8 && value < 0) {
      valueRed = valueRed.substring(0, 2) + '.' + valueRed.substring(2);
    }

    return valueRed;
  }

  onChangeForm() {
    Object.keys(this.form.value).forEach((key: any) => {
      const item: any = this.item;
      item[key] = this.form.value[key]
    });
    this.itemChange.emit(this.item);
  }

  removeItem() {
    if (this.item?.detail) {
      const modalOptions: IConfirmationDialogOptions = {
        title: "Eliminar item",
        message: "¿Seguro desea eliminar " + this.item?.detail + "? ",
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            this.calculateTotals();
            this.remove.emit();
          } else {
            return
          }
        });

    } else {
      this.calculateTotals();
      this.remove.emit();
    }

  }
}

function vendorValidator(control: AbstractControl): any {
  const value = control.value;
  if (!value) return null;
  if (!value._id) return { notFound: true };
  return null;
}